import { Outlet } from 'react-router-dom';
import { AntdCol, AntdGrid, AntdRow, AntdSegmented } from '@ui';
import { useTabs } from './hooks';

const { useBreakpoint } = AntdGrid;

export const ProfileLayout = () => {
  const { sm, md } = useBreakpoint();
  const { handleChange, options, currentTab } = useTabs();

  return (
    <AntdRow justify="space-between">
      <AntdCol xs={24} md={20} lg={16} xl={12} className="flex flex-col">
        <div className="overflow-x-scroll w-full">
          <AntdSegmented
            block={sm}
            value={currentTab}
            options={options}
            onChange={handleChange}
            size={md ? 'middle' : 'large'}
          />
        </div>
        <Outlet />
      </AntdCol>
    </AntdRow>
  );
};
